<template>
  <Transition name="modal-fade">
    <div
      v-if="modelValue"
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      @click.self="handleCancel"
    >
      <Transition name="modal-scale">
        <div
          v-if="modelValue"
          style="max-width: 420px !important;"
          class="bg-surface border border-border rounded-xl shadow-2xl w-full mx-4 animate-in fade-in zoom-in-95 duration-200"
          @click.stop
        >
          <!-- Header -->
          <div class="px-6 py-4 border-b border-border">
            <div class="flex items-start gap-4">
              <!-- Icon -->
              <div
                :class="[
                  'w-12 h-12 rounded-full flex items-center justify-center shrink-0',
                  type === 'danger' ? 'bg-red-500/10' : 'bg-yellow-500/10'
                ]"
              >
                <AlertTriangle
                  :class="[
                    'w-6 h-6',
                    type === 'danger' ? 'text-red-500' : 'text-yellow-500'
                  ]"
                />
              </div>
              
              <!-- Content -->
              <div class="flex-1 min-w-0">
                <h3 class="text-lg font-semibold text-text-main mb-2">
                  {{ title }}
                </h3>
                <p class="text-sm text-text-muted leading-relaxed">
                  {{ message }}
                </p>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="flex items-center justify-end gap-3 px-6 py-4">
            <button
              @click="handleCancel"
              class="px-4 py-2 text-sm font-medium text-text-main bg-background border border-border rounded-lg hover:bg-hover transition-colors"
            >
              {{ cancelText }}
            </button>
            <button
              @click="handleConfirm"
              :class="[
                'px-4 py-2 text-sm font-medium text-white rounded-lg transition-all',
                type === 'danger'
                  ? 'bg-red-500 hover:bg-red-600'
                  : 'bg-brand hover:opacity-90'
              ]"
            >
              {{ confirmText }}
            </button>
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { AlertTriangle } from 'lucide-vue-next'

interface Props {
  modelValue: boolean
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  type?: 'danger' | 'warning'
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
  (e: 'confirm'): void
  (e: 'cancel'): void
}

withDefaults(defineProps<Props>(), {
  confirmText: '确认',
  cancelText: '取消',
  type: 'warning'
})

const emit = defineEmits<Emits>()

const handleConfirm = () => {
  emit('confirm')
  emit('update:modelValue', false)
}

const handleCancel = () => {
  emit('cancel')
  emit('update:modelValue', false)
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-scale-enter-active,
.modal-scale-leave-active {
  transition: all 0.2s ease;
}

.modal-scale-enter-from,
.modal-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
